<script>
export default {}
</script>

<template>
  <div>
    <ul :class="$style.events">
      <li>
        <time datetime="10:03">10:03</time>
        <span><strong>Bat &amp; Ball</strong> On time</span></li
      >
      <li>
        <time datetime="10:03">10:03</time>
        <span><strong>Bat &amp; Ball</strong> On time</span></li
      >
      <li>
        <time datetime="10:03">10:03</time>
        <span><strong>Bat &amp; Ball</strong> On time</span></li
      >
    </ul>
  </div>
</template>

<style lang="scss" module>
@import '@design';
$type: monster;
.events li {
  display: flex;
}
.events time {
  position: relative;
  padding: 0 1.5em;
  color: #ccc;
}

.events time::after {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;
  width: 0.8em;
  height: 0.8em;
  content: '';
  border: 1px rgb(204, 204, 204) solid;
  border-radius: 50%;
  transform: translateX(50%);

  @if $type == monster {
    color: #333;
    background-color: green;
  } @else {
    color: red;
    background-color: red;
  }
}
.events span {
  position: relative;
  padding: 0 1.5em 1.5em 1.5em;
}

.events span::before {
  position: absolute;
  left: 0;
  z-index: 1;
  height: 100%;
  content: '';
  border-left: 1px #ccc solid;
}
.events li:last-child span::before {
  border-left: none;
}
.events strong {
  display: block;
  font-weight: bolder;
}

.events {
  width: 50%;
  margin: 1em;
}
.events:last-child {
  border-left: none;
}

.events *::before,
.events *::after {
  box-sizing: border-box;
}
</style>
